import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { PersonVM } from 'mutation/view-models/registration-beware';
import TablePersons from './table-persons';
import ChooseDate from 'shell/components/shared/choice-date';
import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { DateTime } from 'luxon';

interface AccordionPersonFormProps {
  disabled?: boolean;
  values?: PersonVM | null;
  onChange: (key: keyof PersonVM, value: PersonVM[keyof PersonVM]) => void;
  onChanges: (value: PersonVM) => void;
  onSearch: (values?: PersonVM | null) => Promise<unknown>;
  isBeware?: boolean;
}

const AccordionPersonFormComponent = ({
  disabled,
  values,
  onChange,
  onChanges,
  onSearch,
  isBeware,
}: AccordionPersonFormProps): React.ReactElement => {
  const onChangeChooseDate = useEventCallback(
    (date: DateTime | null, choice?: Array<DatePickerView>) => {
      onChanges({
        birthDate: date,
        birthChoiceDate: choice,
      });
    }
  );

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscalCode"
          fullWidth
          onChange={(event) => {
            onChange('fiscalCode', event?.target.value);
          }}
          value={values?.fiscalCode?.toUpperCase() || ''}
          inputProps={{ maxLength: '16' }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          fullWidth
          onChange={(event) => {
            onChange('surname', event?.target.value);
          }}
          disabled={disabled}
          value={values?.surname || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutSurname"
              checked={values?.withoutSurname || false}
              onChange={() => onChange('withoutSurname', !values?.withoutSurname)}
              inputProps={{ 'aria-label': 'Persona senza cognome' }}
              disabled={disabled}
            />
          }
          label="Persona senza cognome"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          fullWidth
          disabled={disabled}
          onChange={(event) => {
            onChange('name', event?.target.value);
          }}
          value={values?.name || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControlLabel
          control={
            <Checkbox
              id="withoutName"
              disabled={disabled}
              checked={values?.withoutName || false}
              onChange={() => onChange('withoutName', !values?.withoutName)}
              inputProps={{ 'aria-label': 'Persona senza nome' }}
            />
          }
          label="Persona senza nome"
        />
      </Grid>
      <Grid item xs={12}>
        <Grid item xs={12} container spacing={2} alignItems="center">
          <ChooseDate
            label="Data di nascita"
            selected={values?.birthDate || null}
            onChange={onChangeChooseDate}
            choice={values?.birthChoiceDate}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} display="flex" justifyContent="end">
        <Grid item xs={12} md={4}>
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            fullWidth
            onClick={() => onSearch(values)}
            id="reset"
          >
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
      {values?.personsList ? (
        <TablePersons
          values={values}
          onChange={onChange}
          onChanges={onChanges}
          isBeware={isBeware}
        />
      ) : undefined}
    </Grid>
  );
};

AccordionPersonFormComponent.displayName = 'Accordion person form component';

const AccordionPersonForm = memo(AccordionPersonFormComponent);

export default AccordionPersonForm;
